import { heroContent, trustBadges } from '@/mocks/content';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20fashion%20still%20life%20with%20assorted%20designer%20shoes%20handbags%20and%20folded%20clothing%20on%20textured%20beige%20paper%20background%20soft%20morning%20window%20light%20casting%20gentle%20shadows%20clean%20editorial%20composition%20warm%20cream%20and%20sand%20toned%20palette%20high%20end%20fashion%20catalog%20atmosphere%20professional%20photography&width=1600&height=900&seq=hero-main-v2-2026a&orientation=landscape"
          alt="PandabuySpreadsheet fashion discovery hub"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-white mb-4">
          <span className="block text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-wider">
            {heroContent.h1Line1}
          </span>
          <span className="block text-xl md:text-3xl lg:text-4xl italic font-light mt-2 text-white/90">
            {heroContent.h1Line2}
          </span>
        </h1>
        <p className="text-white/75 text-sm md:text-base max-w-[650px] mx-auto leading-relaxed mb-8">
          {heroContent.subheadline}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            View Latest Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/60 text-white font-semibold text-sm hover:bg-white/10 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            Explore Trending
            <i className="ri-fire-line"></i>
          </a>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="absolute bottom-8 left-0 w-full z-10">
        <div className="max-w-[900px] mx-auto px-4 md:px-6 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {trustBadges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-white/80 text-xs md:text-sm whitespace-nowrap">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={badge.icon}></i>
              </span>
              {badge.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}